// components/PageLayout.jsx

import React from "react";

export default function PageLayout({ children, minHeight = "100vh", contentPadding = "16px 0 36px 0" }) {
  return (
    <div
      className="nuvelor-page-shell"
      style={{
        minHeight,
        width: "100%",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "stretch",
      }}
    >
      {/* Side ad areas - only visible on large screens */}
      <div className="side-ad" style={{ minWidth: 0, width: "60px", background: "transparent", display: "none" }} />
      <div
        className="page-content"
        style={{
          flex: 1,
          minWidth: 0,
          width: "100%",
          maxWidth: "var(--page-max, 1100px)",
          padding: contentPadding,
          margin: "0 8px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {children}
      </div>
      <div className="side-ad" style={{ minWidth: 0, width: "60px", background: "transparent", display: "none" }} />
      {/* Adaptive CSS */}
      <style>
        {`
          @media (min-width: 900px) {
            .side-ad { display: block; }
            .page-content { max-width: var(--page-max, 1100px); }
          }
          @media (max-width: 899px) {
            .side-ad { display: none; }
            .page-content { max-width: 100vw; }
          }
        `}
      </style>
    </div>
  );
}
